"use strict";
/*
    Include zoomPopin template,
    Add class "js-open-zoom-popup" to element to trigger click to open zoomPopin
*/
const Panzoom = require("@panzoom/panzoom").default;
var $zoomPopin = $(".js-zoom-popin");
var colorAttribute = $zoomPopin.data("color-attribute");
var $zoomPopinClose = $zoomPopin.find(".js-zoom-popin-close-btn");
var $zoomWrapper = $zoomPopin.find(".js-zoom-wrapper");
var $zoomPopinSlider = $zoomPopin.find(".js-zoom-popin-slider");
var $zoomPopinSliderImages = $zoomPopin.find(".js-zoom-popin-update-image");
var $zoomPopinImageNavigators = $zoomPopin.find(".js-zoom-popin-image-navigation");
var zoomObj = null;
var initialSlideIndex = 0;
var zoomPopinSliderSettings = {
    mobileFirst: true,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true
};

// sets dom elements
function initializeDom() {
    $("body").on("zoomPopin:init", (e, data) =>{

        setSliderImages(data.images);
        initPopinTrigger();
        initSwatches(data.variationAttributes);
        initSlickSlider();
    });
}

// set images
function setSliderImages(images) {
    $zoomPopinSlider.slick("unslick");
    $zoomPopinSlider.empty();

    images.forEach((image) =>{
        var $imageWrapper = $("<div class='m-zoom-popin__slider-image-wrapper'></div>");
        var $image = $(`<img srcset="${image.url}" class="m-zoom-popin__slider-image js-zoom-popin-update-image" data-zoom-url="${image.zoomurl}" alt="${image.alt}" sizes="${image.sizes}"</img>`);

        $imageWrapper.append($image);
        $zoomPopinSlider.append($imageWrapper);
    });

    $zoomPopinSliderImages = $zoomPopin.find(".js-zoom-popin-update-image");
    $zoomPopinSlider.slick(zoomPopinSliderSettings);
}

// init swatches
function initSwatches(variationAttributes) {
    var colorAttributes = variationAttributes.filter(item => item.attributeId == colorAttribute);

    if (colorAttributes.length) {
        var selectedColor = colorAttributes[0].values.filter(attr =>attr.selected === true);

        if (selectedColor.length) {
            $zoomPopin.find(".js-selected-color-attribute").html(selectedColor[0].displayValue);
        }
    }

    $zoomPopin.find("a.swatch-link").on("click", function (e) {
        e.preventDefault();

        $.ajax({
            url: $(this).attr("href"),
            success: function (data) {
                setSliderImages(data.product.images.small);

                var colorData = data.product.variationAttributes.filter(item => item.attributeId == colorAttribute);

                if (colorData.length) {
                    var selectedVariantColor = colorData[0].values.filter(attr =>attr.selected === true);

                    if (selectedVariantColor.length) {
                        $zoomPopin.find(".js-swatch-update").removeClass("selected");
                        $zoomPopin.find("img[data-attr-value='" + selectedVariantColor[0].id + "']").addClass("selected");
                        $zoomPopin.find(".js-selected-color-attribute").html(selectedVariantColor[0].displayValue);
                    }
                }
            }
        });
    });
}

// opens popup
function openPopin() {
    resetZoom();
    $zoomPopin.addClass("open");
    initSlickSlider();
}

// closes popup, resets scroll and zoomable obj
function closePopup() {
    $zoomPopin.removeClass("open");
    resetZoom();
}

// updates zoomable image
function updateImage(imageUrl) {

    $.spinner().start();
    resetZoom();
    var img = new Image();
    img.src = imageUrl;
    img.onload = function () {
        $zoomWrapper.empty().append(img);

        setTimeout(() =>{
            var $zoomableImage = $zoomWrapper.find("img");

            if ($zoomableImage.length) {
                zoomObj = Panzoom($zoomableImage.get(0));
            }

            $.spinner().stop();
        }, 50);
    };
}

// cleans zoom
function resetZoom() {
    if (zoomObj) {
        zoomObj.reset();
        zoomObj.resetStyle();
        zoomObj.destroy();
        zoomObj = null;
    }

    $zoomWrapper.empty();
}

// resets and initializes slick slider
function initSlickSlider() {
    if ($zoomPopinSlider.hasClass("slick-initialized")) {
        $zoomPopinSlider.slick("unslick").slick(zoomPopinSliderSettings);
    } else {
        $zoomPopinSlider.slick(zoomPopinSliderSettings);
    }
}

// popin open trigger event assignment
function initPopinTrigger() {
    $(".js-open-zoom-popin").off("click").on("click", e =>{
        if (!window.mqRespond.status.lgUp) {
            e.preventDefault();
            initialSlideIndex = $(e.target).closest(".slick-slide").data("slick-index");
            openPopin();
        }
    });
}

// sets popin events
function initializeEvents() {
    initPopinTrigger();

    $zoomPopinClose.on("click", e =>{
        e.preventDefault();
        closePopup();
    });

    $zoomPopinSlider.on("init", () => {
        $zoomPopinSliderImages.off("click").on("click", e =>{
            e.preventDefault();
            var $selectedSlide = $(e.target);
            $zoomPopinSliderImages.removeClass("selected");
            $selectedSlide.addClass("selected");
            updateImage($(e.target).data("zoom-url"));

            $zoomPopinSlider.slick("slickGoTo", $selectedSlide.closest(".slick-slide").data("slick-index"));
        });

        $zoomPopinSlider.find("[data-slick-index=" + initialSlideIndex + "] .js-zoom-popin-update-image").trigger("click");

        setTimeout(function () {
            $zoomPopinSlider.slick("slickGoTo", initialSlideIndex);
        }, 100);
    });

    $zoomPopinImageNavigators.on("click", function () {
        var direction = $(this).data("direction");

        if (direction === "left") {
            var $prevSlide = $zoomPopinSlider.find(".slick-current").prev();

            if (!$prevSlide.hasClass("slick-cloned")) {
                $prevSlide.find(".js-zoom-popin-update-image").trigger("click");
            } else {
                $zoomPopinSlider.find(".slick-slide:not(.slick-cloned)").last().find(".js-zoom-popin-update-image").trigger("click");
            }
        } else {
            var $nextSlide = $zoomPopinSlider.find(".slick-current").next();

            if (!$nextSlide.hasClass("slick-cloned")) {
                $nextSlide.find(".js-zoom-popin-update-image").trigger("click");
            } else {
                $zoomPopinSlider.find(".slick-slide:not(.slick-cloned)").first().find(".js-zoom-popin-update-image").trigger("click");
            }
        }
    });
}

exports.init = function init() {
    initializeDom();
    initializeEvents();
};
